import { Select } from "antd";
import { categoryAdding, categoryDelete, categoryUpdate } from "api/news";
import { GlobalContext } from "context/GlobalContext";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { AddIcon, DeleteIcon, EditIcon, SelectDropdown } from "themes/Icon";
import { retrieveUserData } from "../../../utils/cryptoStorage";
import ButtonComp from "../Button";
import CheckboxComp from "../Checkbox";
import InputComp from "../Input";
import ModalComp from "../Modal";
import PopoverComp from "../Popover";
import TagComp from "../Tag";
import style from "./color_select.module.scss";

function ColorChipSelect({
  categoryData,
  setLoadCategory,
  setCategoryId,
  defaultValue,
  categoryId,
}) {
  const userToken = retrieveUserData();
  let admin_user_id, admin_user_name;

  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const [isCheck, setCheck] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [dlt, setDlt] = useState(false);
  const [selectValue, setSelectValue] = useState(
    defaultValue ? defaultValue : null
  );

  const { state } = useContext(GlobalContext);
  const { colorData } = state;

  const [tagColor, setTagColor] = useState(colorData[0]);

  const modalClose = () => {
    setModal(false);
    setCategoryName("");
    setCheck(false);
    setTagColor(colorData[0]);
  };

  const onDropdownVisibleChange = (open) => {
    setSelectOpen(open);
  };

  const editCategory = async (formData) => {
    setLoading(true);
    const apiFunction = isEdit ? categoryUpdate : categoryAdding;
    try {
      const response = await apiFunction(formData);
      if (response.statusCode === 200) {
        toast.success(response.message);
        setLoadCategory((prev) => !prev);
        setCategoryName("");
        setSelectValue(null);
        modalClose();
      } else {
        toast.error(response.message);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCategorySubmit = async () => {
    setLoading(true);

    const formData = {
      news_category_name: categoryName.trim(),
      category_status_flg: 1,
    };
    if (tagColor?.id) {
      formData.tag_color = Number(tagColor?.id);
    }
    if (isEdit) {
      formData.news_category_id = Number(categoryId);
      formData.modified_user_id = Number(admin_user_id);
      formData.modified_user_name = admin_user_name;
    } else {
      (formData.created_user_id = Number(admin_user_id)),
        (formData.created_user_name = admin_user_name);
    }
    if (formData) {
      await editCategory(formData);
    } else {
      setLoading(false);
    }
  };

  const handleDeleteCategory = async (id) => {
    setLoading(true);
    try {
      const response = await categoryDelete(Number(id));

      if (response.statusCode === 200) {
        toast.success(response.message);
        setLoadCategory((prev) => !prev);
        setCategoryName("");
        setSelectValue(null);
        setDlt(false);
        modalClose();
      } else {
        toast.error(response.message);
        setLoadCategory((prev) => !prev);
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setDlt(false);
    }
  };

  const dropdownRender = (menu) => (
    <>
      <div
        onClick={() => {
          setSelectOpen(false);
          setModal(true);
          setEdit(false);
        }}
        className="add-category-container"
      >
        <span className="add-icon">
          <AddIcon />
        </span>
        <h5 className="category-text">Create a new news category</h5>
      </div>
      {categoryData.map((data, i) => (
        <div
          key={i}
          onClick={() => {
            setSelectValue(data?.name);
            setSelectOpen(false);
            setCategoryId(data?.id);
          }}
          className="category-item"
        >
          <span className="category-label">{data?.name}</span>
          <div className="action-container">
            <button
              className="action-btn"
              onClick={(e) => {
                e.stopPropagation();
                setEdit(true);
                setSelectOpen(false);
                setModal(true);
                setCategoryName(data?.name);
                setCheck(true);
                setCategoryId(data?.id);
                const color = colorData.find((item) => item.id === data?.color);
                setTagColor(color);
              }}
            >
              <EditIcon />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setDlt(true);
                setSelectOpen(false);
                setCategoryId(data?.id);
              }}
              className="action-btn"
            >
              <DeleteIcon />
            </button>
          </div>
        </div>
      ))}
    </>
  );

  const modalFooter = (
    <div className="flex align-center justify-end gap-3">
      <ButtonComp onClick={modalClose} variant="secondary">
        Cancel
      </ButtonComp>
      <ButtonComp
        loading={loading}
        disabled={categoryName.trim().length === 0}
        onClick={handleCategorySubmit}
      >
        {isEdit ? "Update" : "Create"}
      </ButtonComp>
    </div>
  );

  const dltModalFooter = (
    <div className="flex align-center justify-end gap-3">
      <ButtonComp onClick={() => setDlt(false)} variant="secondary">
        Cancel
      </ButtonComp>
      <ButtonComp
        variant="danger"
        loading={loading}
        onClick={() => handleDeleteCategory(categoryId)}
      >
        Delete
      </ButtonComp>
    </div>
  );

  const [popover, setPopover] = useState(false);

  const popoverContent = (
    <div className={style["color-box-wrapper"]}>
      {colorData.map((item) => (
        <div
          onClick={() => {
            setPopover(false);
            setTagColor({
              id: item?.id,
              value: item?.value,
            });
          }}
          key={item?.id}
          style={{
            backgroundColor: item?.value,
          }}
          className={`${style["color-box"]} ${
            item?.id == tagColor?.id && style["color-box-active"]
          }`}
        />
      ))}
    </div>
  );

  return (
    <>
      <Select
        value={selectValue}
        open={selectOpen}
        suffixIcon={<SelectDropdown />}
        allowClear
        style={{ width: "100%" }}
        className="chip-select color-select"
        popupClassName="select-popover color-select-popover"
        placeholder="Provide category name"
        options={categoryData.map((data) => ({
          label: data.name,
          value: data.id,
        }))}
        maxTagCount={3}
        dropdownRender={dropdownRender}
        onDropdownVisibleChange={onDropdownVisibleChange}
        onClear={() => {
          setSelectValue(null);
          setCategoryId(null);
        }}
      />
      <ModalComp
        footer={modalFooter}
        CancelClick={() => modalClose()}
        open={modal}
        setOpen={setModal}
        title={isEdit ? "Edit news category" : "Create news category"}
      >
        <div className="flex flex-column gap-4">
          <div>
            <InputComp
              label="Name"
              placeholder="Enter category name"
              id="category-name"
              value={categoryName}
              onChange={(e) => {
                setCategoryName(e.target.value);
              }}
              maxLength={20}
              showCount={true}
            />
          </div>
          <div className={style["color-wrapper"]}>
            <CheckboxComp
              isChecked={isCheck}
              setChecked={setCheck}
              label="Add tag colour"
            />
            {isCheck && (
              <div className={style["tag-container"]}>
                {categoryName && (
                  <TagComp color={tagColor?.value}>{categoryName}</TagComp>
                )}
                <PopoverComp
                  open={popover}
                  setOpen={setPopover}
                  title="Pick color"
                  content={popoverContent}
                >
                  <ButtonComp className={style["color-btn"]} variant="link">
                    Pick color
                  </ButtonComp>
                </PopoverComp>
              </div>
            )}
          </div>
        </div>
      </ModalComp>
      <ModalComp
        footer={dltModalFooter}
        CancelClick={() => modalClose()}
        open={dlt}
        setOpen={setDlt}
        title="Delete Category"
      >
        Are you sure you want to delete the selected category
      </ModalComp>
    </>
  );
}

export default ColorChipSelect;
